package uz.ferro.shop.pages.admin.product

import react.FC
import react.Props
import react.router.Outlet

val AdminProduct = FC<Props> {
    Outlet()
}